import React from "react";
import classes from "../Policy.module.css";

export default function PrivacyPolicy() {
  return (
    <div className={`${classes.policy_container} main-div`}>
      <h1>Privacy Policy</h1>
      <section className={classes.policy_content}>
        <p>
          This Privacy Policy describes how sponsorapet.org (the “Site” or “we”)
          collects, uses, and discloses your Personal Information when you visit
          or make a purchase from the Site.
        </p>
        <h2>Contact</h2>
        <p>
          After reviewing this policy, if you have additional questions, want
          more information about our privacy practices, or would like to make a
          complaint, please contact us by e-mail at{" "}
          <a href="mailto:hello@sponsorapet.org">hello@sponsorapet.org</a>.
        </p>
        <h2>Collecting Personal Information</h2>
        <p>
          When you visit the Site, we collect certain information about your
          device, your interaction with the Site, and information necessary to
          process your purchases. We may also collect additional information if
          you contact us for customer support. In this Privacy Policy, we refer
          to any information about an identifiable individual (including the
          information below) as “Personal Information”. See the list below for
          more information about what Personal Information we collect and why.
        </p>
        <ul>
          <li>
            <p>
              <strong>Device information</strong>
            </p>
            <ul>
              <li>
                <strong>Purpose of collection:</strong> to load the Site
                accurately for you, and to perform analytics on Site usage to
                optimize our Site.
              </li>
              <li>
                <strong>Source of collection:</strong> Collected automatically
                when you access our Site using cookies, log files, web beacons,
                tags, or pixels
              </li>
              <li>
                <strong>Personal Information collected:</strong> version of web
                browser, IP address, time zone, cookie information, what sites
                or products you view, search terms, and how you interact with
                the Site
              </li>
            </ul>
          </li>
          <li>
            <p>
              <strong>Order information</strong>
            </p>
            <ul>
              <li>
                <strong>Purpose of collection:</strong> to provide products or
                services to you to fulfill our contract, to process your payment
                information, arrange for shipping, and provide you with invoices
                and/or order confirmations, communicate with you, screen our
                orders for potential risk or fraud, and when in line with the
                preferences you have shared with us, provide you with
                information or advertising relating to our products or services.
              </li>
              <li>
                <strong>Source of collection:</strong> collected from you.
              </li>
              <li>
                <strong>Disclosure for a business purpose:</strong> shared with
                our processors Shopify [ADD ANY OTHER VENDORS WITH WHOM YOU
                SHARE THIS INFORMATION. FOR
              </li>
              <li>
                <strong>Personal Information collected:</strong> name, billing
                address, shipping address, payment information (including credit
                card numbers ), email address, and phone number.
              </li>
            </ul>
          </li>
          <li>
            <p>
              <strong>Customer support information</strong>
            </p>
            <ul>
              <li>
                <strong>Purpose of collection:</strong> to provide customer
                support.
              </li>
              <li>
                <strong>Source of collection:</strong> collected from you
              </li>
              <li>
                <strong>Disclosure for a business purpose:</strong> No outside
                vendors are used
              </li>
              <li>
                <strong>Personal Information collected:</strong> None is
                collected outside of what you provide
              </li>
            </ul>
          </li>
        </ul>
        <h2>Minors</h2>
        <p>
          The Site is not intended for individuals under the age of [INSERT
          AGE]. We do not intentionally collect Personal Information from
          children. If you are the parent or guardian and believe your child has
          provided us with Personal Information, please contact us at the
          address above to request deletion.
        </p>
        <h2>Sharing Personal Information</h2>
        <p>
          We share your Personal Information with service providers to help us
          provide our services and fulfill our contracts with you, as described
          above. For example:
        </p>
        <ul>
          <li>
            We use AWS to power our online store. You can read more about how
            AWS uses your Personal Information here:{" "}
            <a href="https://aws.amazon.com/privacy/">
              https://aws.amazon.com/privacy/
            </a>
          </li>
          <li>
            We may share your Personal Information to comply with applicable
            laws and regulations, to respond to a subpoena, search warrant or
            other lawful request for information we receive, or to otherwise
            protect our rights.
          </li>
        </ul>
        <h2>Behavioral Advertising</h2>
        <p>
          As described above, we use your Personal Information to provide you
          with targeted advertisements or marketing communications we believe
          may be of interest to you. For example:
        </p>
        <ul>
          <li>
            We use Google Analytics to help us understand how our customers use
            the Site. You can read more about how Google uses your Personal
            Information here:{" "}
            <a href="https://www.google.com/intl/en/policies/privacy/">
              https://www.google.com/intl/en/policies/privacy/
            </a>
            . You can also opt-out of Google Analytics here:{" "}
            <a href="https://tools.google.com/dlpage/gaoptout">
              https://tools.google.com/dlpage/gaoptout
            </a>
            .
          </li>
        </ul>
        <p>
          For more information about how targeted advertising works, you can
          visit the Network Advertising Initiative’s (“NAI”) educational page at{" "}
          <a href="https://www.networkadvertising.org/understanding-online-advertising/how-does-it-work">
            https://www.networkadvertising.org/understanding-online-advertising/how-does-it-work
          </a>
          .
        </p>
        <p>You can opt out of targeted advertising by:</p>
        [INCLUDE OPT-OUT LINKS FROM WHICHEVER SERVICES BEING USED. COMMON LINKS
        INCLUDE:
        <ul>
          <li>
            FACEBOOK -{" "}
            <a href="https://www.facebook.com/settings/?tab=ads">
              https://www.facebook.com/settings/?tab=ads
            </a>
          </li>
          <li>
            GOOGLE -{" "}
            <a href="https://www.google.com/settings/ads/anonymous">
              https://www.google.com/settings/ads/anonymous
            </a>
          </li>
          <li>
            BING -{" "}
            <a href="https://advertise.bingads.microsoft.com/en-us/resources/policies/personalized-ads">
              https://advertise.bingads.microsoft.com/en-us/resources/policies/personalized-ads
            </a>
          </li>
        </ul>
        ]
        <p>
          Additionally, you can opt out of some of these services by visiting
          the Digital Advertising Alliance’s opt-out portal at:{" "}
          <a href="https://optout.aboutads.info/">
            https://optout.aboutads.info/
          </a>
          .
        </p>
        <h2>Using Personal Information</h2>
        <p>
          We use your personal Information to provide our services to you, which
          includes: offering products for sale, processing payments, shipping
          and fulfillment of your order, and keeping you up to date on new
          products, services, and offers.
        </p>
        <h2>Lawful basis</h2>
        <p>
          Pursuant to the General Data Protection Regulation (“GDPR”), if you
          are a resident of the European Economic Area (“EEA”), we process your
          personal information under the following lawful bases:
        </p>
        [INCLUDE ALL THAT APPLY TO YOUR BUSINESS]
        <ul>
          <li>Your consent;</li>
          <li>The performance of the contract between you and the Site;</li>
          <li>Compliance with our legal obligations;</li>
          <li>To protect your vital interests;</li>
          <li>To perform a task carried out in the public interest;</li>
          <li>
            For our legitimate interests, which do not override your fundamental
            rights and freedoms.
          </li>
        </ul>
        <h2>Retention</h2>
        <p>
          When you place an order through the Site, we will retain your Personal
          Information for our records unless and until you ask us to erase this
          information. For more information on your right of erasure, please see
          the ‘Your rights’ section below.
        </p>
        <h2>Automatic decision-making</h2>
        <p>
          If you are a resident of the EEA, you have the right to object to
          processing based solely on automated decision-making (which includes
          profiling), when that decision-making has a legal effect on you or
          otherwise significantly affects you.
        </p>
        <p>
          We DO NOT engage in fully automated decision-making that has a legal
          or otherwise significant effect using customer data.
        </p>
        <p>
          Our processor AWS uses limited automated decision-making to prevent
          fraud that does not have a legal or otherwise significant effect on
          you.
        </p>
        <p>
          Services that include elements of automated decision-making include:
        </p>
        <ul>
          <li>
            Temporary blacklist of IP addresses associated with repeated failed
            transactions. This blacklist persists for a small number of hours.
          </li>
          <li>
            Temporary blacklist of credit cards associated with blacklisted IP
            addresses. This blacklist persists for a small number of days.
          </li>
        </ul>
        <h2>Your rights</h2>
        <p>
          [INCLUDE FOLLOWING SECTION IF YOUR STORE IS LOCATED IN OR IF YOU HAVE
          CUSTOMERS IN EUROPE]
        </p>
        <h3>GDPR</h3>
        <p>
          If you are a resident of the EEA, you have the right to access the
          Personal Information we hold about you, to port it to a new service,
          and to ask that your Personal Information be corrected, updated, or
          erased. If you would like to exercise these rights, please contact us
          through the contact information above. [OR INSERT ALTERNATIVE
          INSTRUCTIONS FOR SENDING ACCESS, ERASURE, CORRECTION, AND PORTABILITY
          REQUESTS]
        </p>
        <p>
          Your Personal Information will be initially processed in Ireland and
          then will be transferred outside of Europe for storage and further
          processing, including to Canada and the United States. For more
          information on how data transfers comply with the GDPR, see Shopify’s
          GDPR Whitepaper:{" "}
          <a href="https://help.shopify.com/en/manual/your-account/privacy/GDPR">
            https://help.shopify.com/en/manual/your-account/privacy/GDPR
          </a>
          .
        </p>
        <h3>CCPA</h3>
        <p>
          If you are a resident of California, you have the right to access the
          Personal Information we hold about you (also known as the ‘Right to
          Know’), to port it to a new service, and to ask that your Personal
          Information be corrected, updated, or erased. If you would like to
          exercise these rights, please contact us through the contact
          information above.
        </p>
        <p>
          If you would like to designate an authorized agent to submit these
          requests on your behalf, please contact us at the address above.
        </p>
        <h2>Cookies</h2>
        <p>
          A cookie is a small amount of information that’s downloaded to your
          computer or device when you visit our Site. We use a number of
          different cookies, including functional, performance, advertising, and
          social media or content cookies. Cookies make your browsing experience
          better by allowing the website to remember your actions and
          preferences (such as login and region selection). This means you don’t
          have to re-enter this information each time you return to the site or
          browse from one page to another. Cookies also provide information on
          how people use the website, for instance whether it’s their first time
          visiting or if they are a frequent visitor.
        </p>
        <p>
          We use the following cookies to optimize your experience on our Site
          and to provide our services.
        </p>
        <h2>Cookies Necessary for the Functioning of the Store</h2>
        <table>
          <thead>
            <tr>
              <th>Name</th>
              <th>Function</th>
              <th>Duration</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>_secure_session_id</td>
              <td>Used in connection with navigation through a storefront.</td>
              <td>24h</td>
            </tr>
            <tr>
              <td>keep_alive</td>
              <td>Used in connection with buyer localization.</td>
              <td>2w</td>
            </tr>
            <tr>
              <td>secure_customer_sig</td>
              <td>Used in connection with customer login.</td>
              <td>20y</td>
            </tr>
          </tbody>
        </table>
        <h2>Reporting and Analytics</h2>
        <table>
          <thead>
            <tr>
              <th>Name</th>
              <th>Function</th>
              <th>Duration</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>_landing_page</td>
              <td>Track landing pages.</td>
              <td>2w</td>
            </tr>
            <tr>
              <td>_orig_referrer</td>
              <td>Track landing pages.</td>
              <td>2w</td>
            </tr>
          </tbody>
        </table>
        <p>
          The length of time that a cookie remains on your computer or mobile
          device depends on whether it is a “persistent” or “session” cookie.
          Session cookies last until you stop browsing and persistent cookies
          last until they expire or are deleted. Most of the cookies we use are
          persistent and will expire between 30 minutes and two years from the
          date they are downloaded to your device.
        </p>
        <p>
          You can control and manage cookies in various ways. Please keep in
          mind that removing or blocking cookies can negatively impact your user
          experience and parts of our website may no longer be fully accessible.
        </p>
        <p>
          Most browsers automatically accept cookies, but you can choose whether
          or not to accept cookies through your browser controls, often found in
          your browser’s “Tools” or “Preferences” menu. For more information on
          how to modify your browser settings or how to block, manage or filter
          cookies can be found in your browser’s help file or through such sites
          as:{" "}
          <a href="http://www.allaboutcookies.org">www.allaboutcookies.org</a>.
        </p>
        <p>
          Additionally, please note that blocking cookies may not completely
          prevent how we share information with third parties such as our
          advertising partners. To exercise your rights or opt-out of certain
          uses of your information by these parties, please follow the
          instructions in the “Behavioral Advertising” section above.
        </p>
        <h2>Do Not Track</h2>
        <p>
          Please note that because there is no consistent industry understanding
          of how to respond to “Do Not Track” signals, we do not alter our data
          collection and usage practices when we detect such a signal from your
          browser.
        </p>
        <h2>Changes</h2>
        <p>
          We may update this Privacy Policy from time to time in order to
          reflect, for example, changes to our practices or for other
          operational, legal, or regulatory reasons.
        </p>
        <h2>Complaints</h2>
        <p>
          As noted above, if you would like to make a complaint, please contact
          us by e-mail or by mail using the details provided under “Contact”
          above.
        </p>
        <p>
          If you are not satisfied with our response to your complaint, you have
          the right to lodge your complaint with the relevant data protection
          authority. You can contact your local data protection authority, or
          our supervisory authority.
        </p>
        <p>Last updated: [April 1, 2024]</p>
      </section>
    </div>
  );
}
